import {
    GET_USER_AUTHORIZATION, SET_USER_AUTHORIZATION
} from '../types/General/userActionTypes'

const initialState = {
    authorization: {}
}

const authorizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_AUTHORIZATION:
            return {
                ...state,
                authorization: action.payload
            }
            break;
        case GET_USER_AUTHORIZATION:
            return {
                ...state
            }
            break;
        default: 
        return state;
    }
}
export default authorizationReducer;